import React from "react";

const ScenarioProgressBar = ({ currentIndex, total }) => {
  const progress = ((currentIndex + 1) / total) * 100;
  return (
    <div className="progress-bar-bg mb-4">
      <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
    </div>
  );
};

export default ScenarioProgressBar;
